// Author YuJiaBei
// Date 2025-06-12 10:55:08

class EmArchBasicData {
    constructor({
                    id = null,
                    sid = '',
                    parentNcid = '',
                    pkGroup = '',
                    pkOrg = '',
                    ncCardCode = '',
                    ncCardStatus = '',
                    code = '',
                    name = '',
                    equipmentCategoryId = '',
                    equipmentStatusId = '',
                    equipmentLevelId = '',
                    locationCode = '',
                    departmentId = '',
                    emAclDeptName = '',
                    installTime = '',
                    serviceLife = '',
                    parentId = '',
                    manufacturerId = '',
                    bdaNameSma = '',
                    bdaPrecoding = '',
                    bdaBillTypeSrc = '',
                    seq = '',
                    specification = '',
                    bdaModel = '',
                    bdaCapitalSrc = '',
                    bdaCheckPeriod = '',
                    bdaInnercode = '',
                    bdaSpecialFlag = '',
                    motorPower = '',
                    motorType = '',
                    purpose = '',
                    bdaCodeSpa = '',
                    responsiblePersonId = '',
                    acceptanceTime = '',
                    bdaScrapDate = '',
                    bdaAssetNo = '',
                    bdaExtendedFieldsA = '',
                    bdaExtendedFieldsB = '',
                    bdaExtendedFieldsC = '',
                    bdaExtendedFieldsD = '',
                    bdaExtendedFieldsE = '',
                    description = '',
                    attachment = '',
                    attachmentList = ''
                }
                = {}) {
        this.id = id;
        this.sid = sid;
        this.parentNcid = parentNcid;
        this.pkGroup = pkGroup;
        this.pkOrg = pkOrg;
        this.ncCardCode = ncCardCode;
        this.ncCardStatus = ncCardStatus;
        this.code = code;
        this.name = name;
        this.equipmentCategoryId = equipmentCategoryId;
        this.equipmentStatusId = equipmentStatusId;
        this.equipmentLevelId = equipmentLevelId;
        this.locationCode = locationCode;
        this.departmentId = departmentId;
        this.emAclDeptName = emAclDeptName;
        this.installTime = installTime;
        this.serviceLife = serviceLife;
        this.parentId = parentId;
        this.manufacturerId = manufacturerId;
        this.bdaNameSma = bdaNameSma;
        this.bdaPrecoding = bdaPrecoding;
        this.bdaBillTypeSrc = bdaBillTypeSrc;
        this.seq = seq;
        this.specification = specification;
        this.bdaModel = bdaModel;
        this.bdaCapitalSrc = bdaCapitalSrc;
        this.bdaCheckPeriod = bdaCheckPeriod;
        this.bdaInnercode = bdaInnercode;
        this.bdaSpecialFlag = bdaSpecialFlag;
        this.motorPower = motorPower;
        this.motorType = motorType;
        this.purpose = purpose;
        this.bdaCodeSpa = bdaCodeSpa;
        this.responsiblePersonId = responsiblePersonId;
        this.acceptanceTime = acceptanceTime;
        this.bdaScrapDate = bdaScrapDate;
        this.bdaAssetNo = bdaAssetNo;
        this.bdaExtendedFieldsA = bdaExtendedFieldsA;
        this.bdaExtendedFieldsB = bdaExtendedFieldsB;
        this.bdaExtendedFieldsC = bdaExtendedFieldsC;
        this.bdaExtendedFieldsD = bdaExtendedFieldsD;
        this.bdaExtendedFieldsE = bdaExtendedFieldsE;
        this.description = description;
        this.attachment = attachment;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new EmArchBasicData();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.archive.emArchBasicData.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        // {
        //     key: 'sid',
        //     label: 'label.em.archive.emArchBasicData.grid.sid',
        //     sortable: true,
        //     isDetail: true,
        //     form: {
        //         type: 'input',
        //         modalMultiSelectedType: 'string'
        //     }
        // },
        // {
        //     key: 'pkGroup',
        //     label: 'label.em.archive.emArchBasicData.grid.pkGroup',
        //     sortable: true,
        //     isDetail: true,
        //     form: {
        //         type: 'input',
        //         modalMultiSelectedType: 'string'
        //     }
        // },
        // {
        //     key: 'pkOrg',
        //     label: 'label.em.archive.emArchBasicData.grid.pkOrg',
        //     sortable: true,
        //     isDetail: true,
        //     form: {
        //         type: 'input',
        //         modalMultiSelectedType: 'string'
        //     }
        // },
        {
            key: 'code',
            label: 'label.em.archive.emArchBasicData.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'epcCode',
            label: 'label.em.archive.emArchBasicData.grid.epcCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'name',
            label: 'label.em.archive.emArchBasicData.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'equipmentCategoryId',
            label: 'label.em.archive.emArchBasicData.grid.equipmentCategoryId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'equipmentCategoryName',
            label: 'label.em.archive.emArchBasicData.grid.equipmentCategoryName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'equipmentStatusId',
            label: 'label.em.archive.emArchBasicData.grid.equipmentStatusId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'status',
            label: 'label.em.archive.emArchBasicData.grid.status',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'equipmentLevelId',
            label: 'label.em.archive.emArchBasicData.grid.equipmentLevelId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'equipmentLevelName',
            label: 'label.em.archive.emArchBasicData.grid.equipmentLevelName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'locationCode',
            label: 'label.em.archive.emArchBasicData.grid.locationCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emArchLocName',
            label: 'label.em.archive.emArchBasicData.grid.emArchLocName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'departmentId',
            label: 'label.em.archive.emArchBasicData.grid.departmentId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'installTime',
            label: 'label.em.archive.emArchBasicData.grid.installTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'serviceLife',
            label: 'label.em.archive.emArchBasicData.grid.serviceLife',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentId',
            label: 'label.em.archive.emArchBasicData.grid.parentId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaNameSma',
            label: 'label.em.archive.emArchBasicData.grid.bdaNameSma',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaPrecoding',
            label: 'label.em.archive.emArchBasicData.grid.bdaPrecoding',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'nodeCode',
            label: 'label.em.archive.emArchBasicData.grid.nodeCode',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'seq',
            label: 'label.em.archive.emArchBasicData.grid.seq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specification',
            label: 'label.em.archive.emArchBasicData.grid.specification',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaModel',
            label: 'label.em.archive.emArchBasicData.grid.bdaModel',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaSpecialFlag',
            label: 'label.em.archive.emArchBasicData.grid.bdaSpecialFlag',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'motorPower',
            label: 'label.em.archive.emArchBasicData.grid.motorPower',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'motorType',
            label: 'label.em.archive.emArchBasicData.grid.motorType',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purpose',
            label: 'label.em.archive.emArchBasicData.grid.purpose',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaCodeSpa',
            label: 'label.em.archive.emArchBasicData.grid.bdaCodeSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaNameSpa',
            label: 'label.em.archive.emArchBasicData.grid.bdaNameSpa',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'responsiblePersonId',
            label: 'label.em.archive.emArchBasicData.grid.responsiblePersonId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'personName',
            label: 'label.em.archive.emArchBasicData.grid.personName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'acceptanceTime',
            label: 'label.em.archive.emArchBasicData.grid.acceptanceTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaScrapDate',
            label: 'label.em.archive.emArchBasicData.grid.bdaScrapDate',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaAssetNo',
            label: 'label.em.archive.emArchBasicData.grid.bdaAssetNo',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaExtendedFieldsA',
            label: 'label.em.archive.emArchBasicData.grid.bdaExtendedFieldsA',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaExtendedFieldsB',
            label: 'label.em.archive.emArchBasicData.grid.bdaExtendedFieldsB',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaExtendedFieldsC',
            label: 'label.em.archive.emArchBasicData.grid.bdaExtendedFieldsC',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaExtendedFieldsD',
            label: 'label.em.archive.emArchBasicData.grid.bdaExtendedFieldsD',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bdaExtendedFieldsE',
            label: 'label.em.archive.emArchBasicData.grid.bdaExtendedFieldsE',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'description',
            label: 'label.em.archive.emArchBasicData.grid.description',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.em.archive.emArchBasicData.grid.attachmentList',
            sortable: true,
            isDetail: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'emAclDeptName',
            label: 'label.em.archive.emArchBasicData.grid.emAclDeptName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'serviceDays',
            label: 'label.em.archive.emArchBasicData.grid.serviceDays',
            sortable: true,
            isDetail: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'serviceRemainRate',
            label: 'label.em.archive.emArchBasicData.grid.serviceRemainRate',
            sortable: true,
            isDetail: true,
            form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    sidFilter: '',
    parentNcidFilter: '',
    pkGroupFilter: '',
    pkOrgFilter: '',
    ncCardCodeFilter: '',
    ncCardStatusFilter: '',
    codeFilter: '',
    epcCodeFilter: '',
    nameFilter: '',
    equipmentStatusIdFilter: '',
    equipmentLevelIdFilter: '',
    locationCodeFilter: '',
    departmentIdFilter: '',
    installTimeRteFilter: '',
    installTimeLteFilter: '',
    serviceLifeFilter: '',
    parentIdFilter: '',
    parentNameFilter: '',
    manufacturerIdFilter: '',
    bdaNameSmaFilter: '',
    bdaPrecodingFilter: '',
    bdaBillTypeSrcFilter: '',
    levelFilter: '',
    nodeCodeFilter: '',
    seqFilter: '',
    specificationFilter: '',
    bdaModelFilter: '',
    bdaCapitalSrcFilter: '',
    bdaCheckPeriodFilter: '',
    bdaInnercodeFilter: '',
    bdaSpecialFlagFilter: '',
    motorPowerFilter: '',
    motorTypeFilter: '',
    purposeFilter: '',
    bdaCodeSpaFilter: '',
    responsiblePersonIdFilter: '',
    responsiblePersonNameFilter: '',
    acceptanceTimeRteFilter: '',
    acceptanceTimeLteFilter: '',
    bdaScrapDateRteFilter: '',
    bdaScrapDateLteFilter: '',
    bdaAssetNoFilter: '',
    bdaExtendedFieldsAFilter: '',
    bdaExtendedFieldsBFilter: '',
    bdaExtendedFieldsCFilter: '',
    bdaExtendedFieldsDFilter: '',
    bdaExtendedFieldsEFilter: '',
    emAclDeptIdFilter: '',
    emAclDeptNameFilter: '',
    emAclDeptNodeCodeFilter: '',
    emAclDeptNodeCodeNameFilter: '',
    emArchLocCodeFilter: '',
    emArchLocNodeCodeFilter: '',
    emArchLocNodeCodeNameFilter: '',
    equipmentCategoryIdFilter: '',
    equipmentCategoryNodeCodeFilter: '',
    equipmentCategoryNodeCodeNameFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    // {
    // key: 'sidFilter',
    // label: 'label.em.archive.emArchBasicData.filter.sid',
    // disabled: false,
    // form: {
    // type: 'input',
    // modalMultiSelectedType: 'string'
    //         }
    // },
    // {
    // key: 'pkGroupFilter',
    // label: 'label.em.archive.emArchBasicData.filter.pkGroup',
    // disabled: false,
    // form: {
    // type: 'input',
    // modalMultiSelectedType: 'string'
    //         }
    // },
    // {
    // key: 'pkOrgFilter',
    // label: 'label.em.archive.emArchBasicData.filter.pkOrg',
    // disabled: false,
    // form: {
    // type: 'input',
    // modalMultiSelectedType: 'string'
    //         }
    // },
    {
        key: 'codeFilter',
        label: 'label.em.archive.emArchBasicData.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'nameFilter',
        label: 'label.em.archive.emArchBasicData.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'equipmentStatusIdFilter',
        label: 'label.em.archive.emArchBasicData.filter.equipmentStatusId',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'equipmentLevelIdFilter',
        label: 'label.em.archive.emArchBasicData.filter.equipmentLevelId',
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentLevel'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'installTimeRteFilter',
        label: 'label.em.archive.emArchBasicData.filter.installTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'installTimeLteFilter',
        label: 'label.em.archive.emArchBasicData.filter.installTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'serviceLifeFilter',
        label: 'label.em.archive.emArchBasicData.filter.serviceLife',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentNameFilter',
        label: 'label.em.archive.emArchBasicData.filter.parentName',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
        }
    },
    {
        key: 'bdaNameSmaFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaNameSma',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaPrecodingFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaPrecoding',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specificationFilter',
        label: 'label.em.archive.emArchBasicData.filter.specification',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaModelFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaModel',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaSpecialFlagFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaSpecialFlag',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'motorPowerFilter',
        label: 'label.em.archive.emArchBasicData.filter.motorPower',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'motorTypeFilter',
        label: 'label.em.archive.emArchBasicData.filter.motorType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purposeFilter',
        label: 'label.em.archive.emArchBasicData.filter.purpose',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaCodeSpaFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaCodeSpa',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppSparePartsSpa'
            , correspondingField: 'code'
        }
    },
    {
        key: 'responsiblePersonNameFilter',
        label: 'label.em.archive.emArchBasicData.filter.responsiblePersonName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acceptanceTimeRteFilter',
        label: 'label.em.archive.emArchBasicData.filter.acceptanceTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'acceptanceTimeLteFilter',
        label: 'label.em.archive.emArchBasicData.filter.acceptanceTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaScrapDateRteFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaScrapDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaScrapDateLteFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaScrapDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaAssetNoFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaAssetNo',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsAFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaExtendedFieldsA',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsBFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaExtendedFieldsB',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsCFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaExtendedFieldsC',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsDFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaExtendedFieldsD',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsEFilter',
        label: 'label.em.archive.emArchBasicData.filter.bdaExtendedFieldsE',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'emAclDeptNameFilter',
        label: 'label.em.archive.emArchBasicData.filter.emAclDeptName',
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
        }
    },
    {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.archive.emArchBasicData.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
        }
    },
    {
        key: 'emArchLocCodeFilter',
        label: 'label.em.archive.emArchBasicData.filter.emArchLocCode',
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emLocation'
            , correspondingField: 'code'
        }
    },
    {
        key: 'emArchLocNodeCodeNameFilter',
        label: 'label.em.archive.emArchBasicData.filter.emArchLocNodeCodeName',
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emLocation'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"emArchLocNodeCode":"nodeCode"}'
        }
    },
    {
        key: 'equipmentCategoryIdFilter',
        label: 'label.em.archive.emArchBasicData.filter.equipmentCategoryId',
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentCategory'
            , correspondingField: 'id'
        }
    },
    {
        key: 'equipmentCategoryNodeCodeNameFilter',
        label: 'label.em.archive.emArchBasicData.filter.equipmentCategoryNodeCodeName',
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentCategory'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"equipmentCategoryNodeCode":"nodeCode"}'
        }
    }
];


const entityFormConfigs = [
    // {
    //     key: 'sid',
    //     label: 'label.em.archive.emArchBasicData.entity.sid',
    //     sortable: true,
    //     disabled: false,
    //     form: {
    //         type: 'input',
    //         modalMultiSelectedType: 'string'
    //     }
    // },
    // {
    //     key: 'pkGroup',
    //     label: 'label.em.archive.emArchBasicData.entity.pkGroup',
    //     sortable: true,
    //     disabled: false,
    //     form: {
    //         type: 'entitySelect',
    //         modalMultiSelectedType: 'string'
    //         , entity: 'emAdmGroup'
    //         , showLabelSelectOne: true
    //     }
    // },
    // {
    //     key: 'pkOrg',
    //     label: 'label.em.archive.emArchBasicData.entity.pkOrg',
    //     sortable: true,
    //     disabled: false,
    //     form: {
    //         type: 'entitySelect',
    //         modalMultiSelectedType: 'string'
    //         , entity: 'emAdmOrganization'
    //         , showLabelSelectOne: true
    //     }
    // },
    {
        key: 'code',
        label: 'label.em.archive.emArchBasicData.entity.code',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'name',
        label: 'label.em.archive.emArchBasicData.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'equipmentCategoryId',
        label: 'label.em.archive.emArchBasicData.entity.equipmentCategoryId',
        sortable: true,
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentCategory'
            , correspondingField: 'id'
        }
    },
    {
        key: 'equipmentStatusId',
        label: 'label.em.archive.emArchBasicData.entity.equipmentStatusId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentStatus'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'equipmentLevelId',
        label: 'label.em.archive.emArchBasicData.entity.equipmentLevelId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entitySelect',
            modalMultiSelectedType: 'string'
            , entity: 'emEquipmentLevel'
            , showLabelSelectOne: true
        }
    },
    {
        key: 'locationCode',
        label: 'label.em.archive.emArchBasicData.entity.locationCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emLocation'
            , correspondingField: 'code'
        }
    },
    {
        key: 'emAclDeptName',
        label: 'label.em.archive.emArchBasicData.entity.emAclDeptName',
        sortable: true,
        disabled: false,
        form: {
            type: 'treeSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclDept'
            , correspondingField: 'name'
            , fieldsBindingByEntityModalSelected: '{"departmentId":"id"}'
        }
    },
    {
        key: 'installTime',
        label: 'label.em.archive.emArchBasicData.entity.installTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'serviceLife',
        label: 'label.em.archive.emArchBasicData.entity.serviceLife',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'parentId',
        label: 'label.em.archive.emArchBasicData.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emArchBasicData'
            , correspondingField: 'id'
        }
    },
    {
        key: 'bdaNameSma',
        label: 'label.em.archive.emArchBasicData.entity.bdaNameSma',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaPrecoding',
        label: 'label.em.archive.emArchBasicData.entity.bdaPrecoding',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'seq',
        label: 'label.em.archive.emArchBasicData.entity.seq',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'specification',
        label: 'label.em.archive.emArchBasicData.entity.specification',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaModel',
        label: 'label.em.archive.emArchBasicData.entity.bdaModel',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaSpecialFlag',
        label: 'label.em.archive.emArchBasicData.entity.bdaSpecialFlag',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'motorPower',
        label: 'label.em.archive.emArchBasicData.entity.motorPower',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'motorType',
        label: 'label.em.archive.emArchBasicData.entity.motorType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purpose',
        label: 'label.em.archive.emArchBasicData.entity.purpose',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaCodeSpa',
        label: 'label.em.archive.emArchBasicData.entity.bdaCodeSpa',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppSparePartsSpa'
            , correspondingField: 'code'
        }
    },
    {
        key: 'responsiblePersonId',
        label: 'label.em.archive.emArchBasicData.entity.responsiblePersonId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , required: true
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'acceptanceTime',
        label: 'label.em.archive.emArchBasicData.entity.acceptanceTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaScrapDate',
        label: 'label.em.archive.emArchBasicData.entity.bdaScrapDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaAssetNo',
        label: 'label.em.archive.emArchBasicData.entity.bdaAssetNo',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsA',
        label: 'label.em.archive.emArchBasicData.entity.bdaExtendedFieldsA',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsB',
        label: 'label.em.archive.emArchBasicData.entity.bdaExtendedFieldsB',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsC',
        label: 'label.em.archive.emArchBasicData.entity.bdaExtendedFieldsC',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsD',
        label: 'label.em.archive.emArchBasicData.entity.bdaExtendedFieldsD',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bdaExtendedFieldsE',
        label: 'label.em.archive.emArchBasicData.entity.bdaExtendedFieldsE',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'description',
        label: 'label.em.archive.emArchBasicData.entity.description',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.em.archive.emArchBasicData.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]

export {
    EmArchBasicData, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
